import {api} from "@/services/Api";
import DataType from "@/entity/DataType";

const STORAGE_KEY = 'masterStore';

function loadFromStorage(): { dataTypes: DataType[], lastSync: string | null } {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw) {
            const parsed = JSON.parse(raw);
            return {
                dataTypes: (parsed.dataTypes || []).map((dt: any) => new DataType(dt)),
                lastSync: parsed.lastSync || null,
            };
        }
    } catch (e) {
    }
    return {dataTypes: [], lastSync: null};
}

function saveToStorage(state: MasterState) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
            dataTypes: state.dataTypes,
            lastSync: state.lastSync,
        }));
    } catch (e) {
    }
}

const persisted = loadFromStorage();

export interface MasterState {
    dataTypes: DataType[],
    lastSync: string | null,
    isSyncing: boolean,
}

const state: MasterState = {
    dataTypes: persisted.dataTypes,
    lastSync: persisted.lastSync,
    isSyncing: false,
}

const mutations = {
    SET_DATA_TYPES(state: MasterState, payload: any) {
        state.dataTypes = payload
        saveToStorage(state);
    },
    SET_LAST_SYNC(state: MasterState, at: string) {
        state.lastSync = at;
        saveToStorage(state);
    },
    SET_SYNCING(state: MasterState, value: boolean) {
        state.isSyncing = value;
    },
}

const actions = {
    async syncMaster({commit, state}: any) {
        if (state.isSyncing) return;
        commit('SET_SYNCING', true);
        try {
            // Route PUBLIQUE cote master (^/api est en PUBLIC_ACCESS). Y attacher le
            // jeton ne sert a rien et la fait echouer des qu'il est perime : le firewall
            // est stateless, l'authentificateur JWT s'execute des qu'un en-tete
            // Authorization est present et refuse un jeton invalide, meme ici.
            const res = await api.post(api.master, 'api/sync', {
                since: state.lastSync,
            }, {params: {noAuth: true}});
            if (res?.data?.state?.dataTypes) {
                const updates = res.data.state.dataTypes.updates || {};
                const deleted = res.data.state.dataTypes.deleted || [];

                const currentMap: Record<string, DataType> = {};
                state.dataTypes.forEach((dt: DataType) => {
                    currentMap[String(dt.id)] = dt;
                });

                for (const key in updates) {
                    currentMap[key] = new DataType(updates[key]);
                }
                for (const id of deleted) {
                    delete currentMap[String(id)];
                }

                commit('SET_DATA_TYPES', Object.values(currentMap));
                commit('SET_LAST_SYNC', res.data.at);
            }
        } catch (e) {
            console.error('MasterStore syncMaster error', e);
        } finally {
            commit('SET_SYNCING', false);
        }
    },
    async loadDataTypes({dispatch, state}: any) {
        if (state.dataTypes.length > 0) return state.dataTypes;
        await dispatch('syncMaster');
        return state.dataTypes;
    },
}

const getters = {
    getDataType: (state: any) => (id: any) => {
        for (let data of state.dataTypes) {
            if (data.id === id || data.code === id) {
                return data
            }
        }
        return id;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
